import { useLang } from "@/i18n";
import { Reveal } from "@/components/Reveal";

const IMG = "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=1200&q=80";

export default function Manifesto() {
  const { t } = useLang();

  return (
    <section id="manifesto" data-testid="manifesto-section" className="bg-[#FAF8F5] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-14 lg:grid-cols-[1fr_1.4fr] lg:gap-20">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <Reveal>
              <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#C87A57]">{t.manifesto.overline}</p>
              <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium leading-tight tracking-tight text-[#0E1B2A]">
                {t.manifesto.titleA}
                <br />
                <span className="italic text-[#2C5E7A]">{t.manifesto.titleB}</span>
              </h2>
            </Reveal>
            <Reveal delay={0.15} className="mt-10 hidden lg:block">
              <div className="overflow-hidden rounded-2xl shadow-[0_30px_60px_-20px_rgba(14,27,42,0.25)]">
                <img src="/images/manifesto.jpg" onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = IMG; }} alt="Professionnelle du nettoyage Service Plus" className="h-72 w-full object-cover transition-transform duration-700 hover:scale-105" />
              </div>
            </Reveal>
          </div>

          <div>
            {t.manifesto.chapters.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.06}>
                <div
                  data-testid={`manifesto-chapter-${i + 1}`}
                  className="group grid grid-cols-[64px_1fr] gap-5 border-t border-[#0E1B2A]/10 py-10 sm:grid-cols-[110px_1fr] sm:gap-10 transition-colors duration-500 hover:bg-white/60"
                >
                  <span className="font-display text-4xl sm:text-5xl font-semibold text-[#D4AF37]/70 transition-colors duration-500 group-hover:text-[#C87A57]">
                    {c.n}
                  </span>
                  <div>
                    <h3 className="font-serif text-xl sm:text-2xl font-semibold text-[#0E1B2A]">{c.t}</h3>
                    <p className="mt-3 text-sm sm:text-base leading-relaxed text-[#475569]">{c.d}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
